/*
 *
 * Set Pin constants
 *
 */

export const SUBMIT_SETPIN_FORM = 'app/SetPin/SUBMIT_SETPIN_FORM';
